/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'
import moment from 'moment'

import { homePath, transformData } from '@/utils'
import { useCarQuery, CarCarStatusChoices } from '@/apollo/graphql'
import { ICar, TFormSubmit } from '@/types'
import { useAPI } from '@/hooks'

interface IUseData {
  id?: string
}

const defaultData: Partial<ICar> = {
  status: CarCarStatusChoices.WaitingForSale,
}

export const useData = ({ id }: IUseData) => {
  const navigate: NavigateFunction = useNavigate()
  const { submitting, sendForm } = useAPI()
  const [data, setData] = useState<any>(defaultData)

  const { loading } = useCarQuery({
    skip: !id,
    fetchPolicy: 'network-only',
    variables: {
      id: id || '',
    },
    onCompleted: res => {
      if (res.car) {
        setData({
          ...res.car,
          status: res.car.status || CarCarStatusChoices.WaitingForSale,
        })
      }
    },
  })

  const onSubmit: TFormSubmit<ICar> = useCallback(
    (path, isEdit, callback) => d => {
      delete d.driver
      if (d.insuranceExpDate) {
        d.insuranceExpDate = moment(d.insuranceExpDate).format('YYYY-MM-DD')
      }
      if (d.licenceExpDate) {
        d.licenceExpDate = moment(d.licenceExpDate).format('YYYY-MM-DD')
      }
      sendForm(
        {
          path,
          method: isEdit ? 'PUT' : 'POST',
          data: transformData(d),
          callback,
        },
        { showNotify: true },
      )
    },
    [sendForm],
  )

  const onCancel = useCallback(() => {
    navigate(homePath)
  }, [navigate])

  return {
    loading,
    submitting,
    data,
    onSubmit,
    onCancel,
  }
}
